import qs from 'query-string';
import { get } from 'lodash';

export const getDashboardData = (query, config) => {
  const { locale, fromYear, toYear } = query;
  let q = '';
  if (fromYear && toYear) {
    q = `date GE ${fromYear}-01-01 AND date LE ${toYear}-12-31`
  }
  const queryString = qs.stringify({ q, lang: locale });
  return fetch(`${config.dashboardAPI}/mainDashboards.xqy?${queryString}`, {
    mode: 'cors'
  }).then(resp => resp.json());
};



// WEBPACK FOOTER //
// ./src/utils/dashboard-api.js